import { LoaderFunction, LoaderFunctionArgs, replace } from 'react-router-dom';

import SessionStorage from '../../../shared/services/SessionStorage';

/**
 * If the federated sign-in flow stored the original URL in Session Storage,
 * restore it to search params, so that it can be parsed further.
 */
export function withCallbackLoader(loader: LoaderFunction) {
  return (args: LoaderFunctionArgs) => {
    const sessionStorage = SessionStorage.getInstance();
    const redirectedFrom = sessionStorage.getItem('redirectedFrom');

    if (redirectedFrom) {
      sessionStorage.removeItem('redirectedFrom');
      return replace(`${import.meta.env.VITE_CHECKOUT_URL}${redirectedFrom}`);
    }

    return loader(args);
  };
}
